export default __webpack_public_path__ + "static/media/pic_roadmap.67d2921b.png";